<template>
    <!-- El layout (layouts/Menu.vue) fuerza padding-top: 0 en su v-content, asi que
         este wrapper interno es el que deja libre el espacio de la barra superior.
         Sin el, el header tapa la primera fila. Todas las vistas lo usan igual. -->
    <v-content>
    <v-container fluid>

        <!-- Tablero de excepciones. Primero los numeros que obligan a actuar:
             para un centro de operaciones lo importante no es el mapa lindo, es
             saber quien NO esta reportando. -->
        <v-row dense class="mb-1">
            <v-col cols="6" md="3">
                <v-card class="tarjeta-cifra" outlined>
                    <div class="cifra">{{ cifras.enTurno }}</div>
                    <div class="rotulo">En turno</div>
                </v-card>
            </v-col>
            <v-col cols="6" md="3">
                <v-card class="tarjeta-cifra ok" outlined>
                    <div class="cifra">{{ cifras.reportando }}</div>
                    <div class="rotulo">Reportando</div>
                    <!-- Sin esto los numeros no cierran: en turno no era la suma de
                         reportando + sin reportar, y quien mira busca los que faltan. -->
                    <div class="rotulo-extra" v-if="cifras.demorados > 0">+{{ cifras.demorados }} demorado(s)</div>
                </v-card>
            </v-col>
            <v-col cols="6" md="3">
                <v-card class="tarjeta-cifra alerta" outlined :class="{ pulso: cifras.sinReportar > 0 }">
                    <div class="cifra">
                        {{ cifras.sinReportar }}
                        <v-icon v-if="cifras.sinReportar > 0" color="red darken-2" class="ml-1">error</v-icon>
                    </div>
                    <div class="rotulo">Sin reportar</div>
                </v-card>
            </v-col>
            <v-col cols="6" md="3">
                <v-card class="tarjeta-cifra aviso" outlined>
                    <div class="cifra">{{ cifras.bateriaBaja }}</div>
                    <div class="rotulo">Bateria baja</div>
                </v-card>
            </v-col>
        </v-row>

        <v-alert v-if="errorMsg" type="error" dense class="mb-2">
            {{ errorMsg }}
            <!-- Firestore desprende el listener para siempre cuando falla, asi que
                 sin este boton la unica salida es recargar la pagina. -->
            <v-btn small text color="white" class="ml-2" @click="escuchar">Reintentar</v-btn>
        </v-alert>

        <!-- Un intento de falsear la ubicacion no es un problema tecnico: es una
             persona tratando de simular una ronda. Se avisa aparte de todo lo demas. -->
        <v-alert v-if="conIntegridad.length" type="error" dense prominent class="mb-2">
            <div class="font-weight-bold">Se detecto ubicacion simulada</div>
            <div class="caption">
                {{ conIntegridad.map(nombreDe).join(', ') }}.
                Los puntos simulados fueron rechazados y el intento quedo registrado.
            </div>
        </v-alert>

        <v-row>
            <!-- Mapa -->
            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title class="py-2">
                        <v-icon left>my_location</v-icon>
                        En vivo
                        <v-chip x-small class="ml-2" :color="colorConexion" text-color="white">
                            {{ textoConexion }}
                        </v-chip>
                        <v-spacer/>
                        <v-switch
                                v-model="soloEnTurno"
                                label="Solo en turno"
                                dense
                                hide-details
                                class="mt-0 mr-3 caption"
                        />
                        <v-btn small text @click="ajustarVista">
                            <v-icon small left>zoom_out_map</v-icon>
                            Centrar
                        </v-btn>
                    </v-card-title>

                    <GmapMap
                            ref="mapa"
                            :options="{
                                zoomControl: true,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                rotateControl: false,
                                fullscreenControl: true
                            }"
                            :center="centroInicial"
                            :zoom="12"
                            map-type-id="roadmap"
                            style="width: 100%; height: 520px"
                    >
                        <template v-if="google">
                            <GmapMarker
                                    v-for="v in conPosicion"
                                    :key="v.id"
                                    :position="{ lat: v.lat, lng: v.lng }"
                                    :icon="iconoDe(v)"
                                    :z-index="zIndexDe(v)"
                                    :clickable="true"
                                    @click="seleccionar(v)"
                            />
                            <GmapInfoWindow
                                    v-if="seleccionado && tienePosicion(seleccionado)"
                                    :position="{ lat: seleccionado.lat, lng: seleccionado.lng }"
                                    :opened="true"
                                    :options="opcionesGlobo"
                                    @closeclick="seleccionadoId = null"
                            >
                                <div class="globo">
                                    <div class="globo-nombre">{{ nombreDe(seleccionado) }}</div>
                                    <div class="globo-linea">{{ seleccionado.cargo || 'Sin cargo' }}</div>
                                    <div class="globo-linea" v-if="seleccionado.puesto">Puesto: {{ seleccionado.puesto }}</div>
                                    <div class="globo-linea" v-if="seleccionado.area">Area: {{ seleccionado.area }}</div>
                                    <div class="globo-estado" :class="clase(seleccionado)">{{ descripcion(seleccionado) }}</div>
                                    <div class="globo-linea">Ultimo aviso: {{ textoRelativo(seleccionado.ultimoLatido) }}</div>
                                    <div class="globo-linea" v-if="seleccionado.ultimoFix">
                                        Ultima posicion: {{ textoRelativo(seleccionado.ultimoFix) }}
                                        <span v-if="seleccionado.accuracy"> (±{{ Math.round(seleccionado.accuracy) }} m)</span>
                                    </div>
                                    <div class="globo-linea" v-if="tieneBateria(seleccionado)">
                                        Bateria: {{ seleccionado.bateria.nivel }}%{{ seleccionado.bateria.cargando ? ' cargando' : '' }}
                                    </div>
                                    <div class="globo-linea" v-if="seleccionado.puntosDescartados > 0">
                                        {{ seleccionado.puntosDescartados }} puntos descartados por calidad
                                    </div>
                                    <div class="globo-integridad" v-if="seleccionado.alertasIntegridad > 0">
                                        {{ seleccionado.alertasIntegridad }} intento(s) de ubicacion simulada
                                    </div>
                                    <v-btn
                                            v-if="puedeVerRecorridos"
                                            x-small color="primary" class="mt-2"
                                            @click="verRecorrido(seleccionado)">
                                        Ver recorrido de hoy
                                    </v-btn>
                                </div>
                            </GmapInfoWindow>
                        </template>
                    </GmapMap>

                    <v-card-text class="py-2 caption leyenda">
                        <span class="marca circulo ok"></span> Reportando (menos de {{ UMBRAL_OK }} min)
                        <span class="marca triangulo aviso ml-4"></span> Demorado
                        <span class="marca cuadrado alerta ml-4"></span> Sin reportar (mas de {{ UMBRAL_ALERTA }} min)
                        <span class="marca circulo chico fuera ml-4"></span> Fuera de turno
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Lista, ordenada por gravedad: lo que hay que mirar primero, arriba -->
            <v-col cols="12" md="4">
                <v-card>
                    <v-card-title class="py-2">
                        <v-icon left>list_alt</v-icon>
                        Personal
                        <v-spacer/>
                        <span class="caption grey--text">{{ visibles.length }}</span>
                    </v-card-title>

                    <v-text-field
                            v-model="busqueda"
                            dense
                            outlined
                            hide-details
                            clearable
                            placeholder="Buscar por nombre o puesto"
                            prepend-inner-icon="search"
                            class="mx-3 mb-2"
                    />

                    <div v-if="cargando" class="pa-6 text-center grey--text">
                        <v-progress-circular indeterminate size="28" color="primary"/>
                        <div class="caption mt-2">Conectando...</div>
                    </div>

                    <!-- Estado vacio explicado: apenas se despliega esto, la coleccion
                         esta vacia hasta que alguien abre turno con la app nueva. Sin
                         este texto parece que la pantalla esta rota. -->
                    <div v-else-if="registros.length === 0" class="pa-5 text-center grey--text">
                        <v-icon size="40" color="grey lighten-1">satellite_alt</v-icon>
                        <div class="body-2 mt-2">Todavia no hay reportes en vivo.</div>
                        <div class="caption mt-1">
                            Esta pantalla se llena cuando los vigilantes abren turno con la
                            version nueva de la app movil.
                        </div>
                    </div>

                    <div v-else-if="visibles.length === 0" class="pa-5 text-center grey--text">
                        <div class="body-2">Sin resultados para este filtro.</div>
                    </div>

                    <v-list v-else dense class="lista-personal">
                        <v-list-item
                                v-for="v in visibles"
                                :key="v.id"
                                @click="seleccionar(v, true)"
                                :class="{ activo: seleccionado && seleccionado.id === v.id }"
                        >
                            <v-list-item-icon class="mr-3">
                                <!-- Icono ademas del color: el estado se puede leer sin
                                     distinguir rojo de verde. -->
                                <v-icon :color="colorEstado(v)">{{ iconoEstado(v) }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="body-2">{{ nombreDe(v) }}</v-list-item-title>
                                <v-list-item-subtitle class="caption">
                                    {{ v.puesto || v.cargo || 'Sin puesto' }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle class="caption" :class="claseTexto(v)">
                                    {{ descripcion(v) }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-if="v.alertasIntegridad > 0" class="caption red--text font-weight-bold">
                                    <v-icon x-small color="red">gpp_bad</v-icon>
                                    Ubicacion simulada detectada
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action class="ml-1">
                                <div class="text-right">
                                    <div class="caption" :class="claseBateria(v)" v-if="tieneBateria(v)">
                                        <v-icon x-small :color="colorBateria(v)">
                                            {{ v.bateria.cargando ? 'battery_charging_full' : 'battery_std' }}
                                        </v-icon>
                                        {{ v.bateria.nivel }}%
                                    </div>
                                    <div class="caption grey--text">{{ textoCorto(v.ultimoLatido) }}</div>
                                </div>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    </v-content>
</template>

<script>
    import { gmapApi } from 'vue2-google-maps'
    import { mapState } from 'vuex'
    import { db } from '@/plugins/db'

    // Minutos desde el ultimo aviso de la app.
    //
    // Son generosos a proposito. El latido de la app se dispara con un
    // setInterval dentro del WebView, y Android puede ralentizar esos temporizadores
    // cuando la pantalla esta apagada. Con umbrales cortos habria falsas alarmas
    // constantes; con estos, un rojo significa de verdad que la app no esta
    // corriendo. El error, si ocurre, es hacia el lado seguro: se avisa de mas,
    // nunca de menos.
    const UMBRAL_OK = 5
    const UMBRAL_ALERTA = 20

    // Forma de cada estado en el mapa. Circulo = todo bien, triangulo = atencion,
    // cuadrado = alarma. La forma se lee sin depender del color.
    const FORMAS = {
        'ok':           { path: 'CIRCLE', scale: 7 },
        'demorado':     { path: 'M 0,-10 L 9,6 L -9,6 Z', scale: 1 },
        'sin-reportar': { path: 'M -8,-8 H 8 V 8 H -8 Z', scale: 1 },
        'detenido':     { path: 'M -8,-8 H 8 V 8 H -8 Z', scale: 1 },
        'sin-datos':    { path: 'M -8,-8 H 8 V 8 H -8 Z', scale: 1 },
        'fuera':        { path: 'CIRCLE', scale: 5 }
    }

    const COLORES = {
        'ok': '#2e7d32',
        'demorado': '#ef6c00',
        'sin-reportar': '#c62828',
        'detenido': '#c62828',
        'sin-datos': '#c62828',
        'fuera': '#9e9e9e'
    }

    // Con que prioridad se ordena la lista. Lo que exige atencion, arriba.
    const PESO = {
        'detenido': 5,
        'sin-reportar': 4,
        'sin-datos': 3,
        'demorado': 2,
        'ok': 1,
        'fuera': 0
    }

    export default {
        name: 'EnVivo',
        data () {
            return {
                UMBRAL_OK,
                UMBRAL_ALERTA,
                // Documentos crudos de `posiciones_actuales`: son lo que el propio
                // telefono del vigilante asevera. `registros` los cruza con `users`.
                reportes: [],
                cargando: true,
                errorMsg: '',
                soloEnTurno: true,
                busqueda: '',
                // Se guarda el ID, no el objeto. `registros` se reemplaza entero en
                // cada snapshot, asi que una referencia al objeto viejo dejaba el globo
                // congelado: seguia mostrando la posicion y el "hace X min" de cuando
                // se hizo clic, y llegaba a marcar "sin reportar" a alguien que estaba
                // reportando bien.
                seleccionadoId: null,
                // Se incrementa con un temporizador para que los "hace X min" se
                // recalculen: los datos no cambian, pero el paso del tiempo si.
                ahora: Date.now(),
                yaCentre: false,
                centroInicial: { lat: 4.6097, lng: -74.0817 }
            }
        },
        computed: {
            google: gmapApi,

            ...mapState({
                usuarios: state => state.user.users
            }),

            porUsuario () {
                const mapa = new Map()
                this.reportes.forEach(r => mapa.set(r.userId || r.id, r))
                return mapa
            },

            /*
             * Quien esta en turno sale de `users`, NO del documento que escribe el
             * telefono.
             *
             * Las reglas dejan que cada persona escriba su propio documento de
             * `posiciones_actuales`, asi que un vigilante con sus credenciales podia
             * poner `enTurno: false` desde afuera de la app -o simplemente no escribir
             * nada- y DESAPARECER de esta pantalla: no figuraba en rojo, no sumaba a
             * "sin reportar", no aparecia. Fallaba abierto.
             *
             * Cruzando con `users` (que solo el panel puede modificar), la ausencia del
             * documento pasa a ser una ALARMA en lugar de invisibilidad.
             */
            registros () {
                const lista = []
                this.usuarios.forEach(u => {
                    const id = u.id
                    if (!id) return
                    const vivo = this.porUsuario.get(id)
                    // Se muestran los que estan en turno y, ademas, los que tienen un
                    // reporte reciente aunque ya lo hayan cerrado.
                    if (u.enTurno !== true && !vivo) return

                    const nombreUsuario = ((u.first_name || '') + ' ' + (u.last_name || '')).trim()

                    lista.push(Object.assign({}, vivo || {}, {
                        id: id,
                        userId: id,
                        nombre: (vivo && vivo.nombre) || nombreUsuario || u.email || null,
                        cargo: (vivo && vivo.cargo) || u.role || null,
                        area: (vivo && vivo.area) || u.area || null,
                        puesto: (vivo && vivo.puesto) || u.position || null,
                        // Lo decide el panel, no el dispositivo.
                        enTurno: u.enTurno === true,
                        conReporte: !!vivo
                    }))
                })
                return lista
            },

            seleccionado () {
                if (!this.seleccionadoId) return null
                return this.registros.find(v => v.id === this.seleccionadoId) || null
            },

            // `pixelOffset` exige una instancia de google.maps.Size: con un objeto
            // plano el API tira InvalidValueError dentro del constructor del
            // InfoWindow, donde no hay try/catch posible, y el globo no abre nunca.
            opcionesGlobo () {
                if (!this.google) return {}
                return { pixelOffset: new this.google.maps.Size(0, -34) }
            },

            puedeVerRecorridos () {
                return this.$store.getters.puedeVerModulo('tracking')
            },

            colorConexion () {
                if (this.errorMsg) return 'red'
                return this.cargando ? 'grey' : 'green'
            },

            textoConexion () {
                if (this.errorMsg) return 'sin conexion'
                return this.cargando ? 'conectando' : 'en linea'
            },

            visibles () {
                const texto = (this.busqueda || '').toLowerCase().trim()
                return this.registros
                    .filter(v => !this.soloEnTurno || v.enTurno === true)
                    .filter(v => {
                        if (!texto) return true
                        return ((v.nombre || '') + ' ' + (v.puesto || '') + ' ' + (v.area || '') + ' ' + (v.cargo || ''))
                            .toLowerCase().includes(texto)
                    })
                    .slice()
                    .sort((a, b) => {
                        const pesoA = PESO[this.estadoDe(a)] || 0
                        const pesoB = PESO[this.estadoDe(b)] || 0
                        if (pesoA !== pesoB) return pesoB - pesoA
                        return (a.nombre || '').localeCompare(b.nombre || '')
                    })
            },

            conPosicion () {
                return this.visibles.filter(v => this.tienePosicion(v))
            },

            conIntegridad () {
                return this.registros.filter(v => v.enTurno === true && v.alertasIntegridad > 0)
            },

            cifras () {
                const enTurno = this.registros.filter(v => v.enTurno === true)
                let reportando = 0
                let demorados = 0
                let sinReportar = 0
                let bateriaBaja = 0

                enTurno.forEach(v => {
                    const estado = this.estadoDe(v)
                    if (estado === 'ok') reportando++
                    if (estado === 'demorado') demorados++
                    if (estado === 'sin-reportar' || estado === 'detenido' || estado === 'sin-datos') sinReportar++
                    if (this.tieneBateria(v) && v.bateria.nivel <= 20 && !v.bateria.cargando) bateriaBaja++
                })

                return { enTurno: enTurno.length, reportando, demorados, sinReportar, bateriaBaja }
            }
        },
        methods: {
            // ------------------------------------------------------- Clasificacion

            minutosDesde (valor) {
                const fecha = this.aFecha(valor)
                if (!fecha) return null
                return (this.ahora - fecha.getTime()) / 60000
            },

            aFecha (valor) {
                if (!valor) return null
                if (typeof valor.toDate === 'function') return valor.toDate()
                if (valor instanceof Date) return valor
                if (valor.seconds) return new Date(valor.seconds * 1000)
                return null
            },

            estadoDe (v) {
                if (v.enTurno !== true) return 'fuera'
                // En turno y sin ningun documento de posicion: o nunca reporto, o
                // alguien borro el documento. En los dos casos es una alarma.
                if (!v.conReporte) return 'sin-datos'
                // El propio dispositivo avisa que el seguimiento no esta corriendo
                // (permiso revocado, GPS apagado). Es peor que la falta de datos,
                // porque es una falla confirmada y no una sospecha.
                if (v.watcherActivo === false) return 'detenido'

                const min = this.minutosDesde(v.ultimoLatido)
                if (min === null) return 'sin-datos'
                if (min > UMBRAL_ALERTA) return 'sin-reportar'
                if (min > UMBRAL_OK) return 'demorado'
                return 'ok'
            },

            clase (v) {
                const estado = this.estadoDe(v)
                if (estado === 'ok') return 'ok'
                if (estado === 'demorado') return 'aviso'
                if (estado === 'fuera') return 'fuera'
                return 'alerta'
            },

            // Los tonos base de Vuetify (green #4CAF50, orange #FF9800) no llegan a
            // 4.5:1 sobre blanco a 12 px. Se usan las variantes oscuras.
            claseTexto (v) {
                const c = this.clase(v)
                if (c === 'ok') return 'green--text text--darken-3'
                if (c === 'aviso') return 'orange--text text--darken-4'
                if (c === 'fuera') return 'grey--text text--darken-1'
                return 'red--text text--darken-2'
            },

            descripcion (v) {
                const estado = this.estadoDe(v)
                if (estado === 'fuera') return 'Fuera de turno'
                if (estado === 'detenido') return v.motivo || 'Seguimiento detenido en el dispositivo'
                if (estado === 'sin-datos') return 'En turno, sin ningun reporte'

                const min = Math.round(this.minutosDesde(v.ultimoLatido))
                if (estado === 'sin-reportar') return 'Sin reportar hace ' + this.humano(min)
                if (estado === 'demorado') return 'Ultimo reporte hace ' + this.humano(min)
                return 'Reportando normalmente'
            },

            // ------------------------------------------------------------- Formato

            humano (minutos) {
                if (minutos === null || isNaN(minutos)) return 'un rato'
                if (minutos < 1) return 'menos de 1 min'
                if (minutos < 60) return Math.round(minutos) + ' min'
                const horas = Math.floor(minutos / 60)
                const resto = Math.round(minutos % 60)
                return horas + ' h' + (resto > 0 ? ' ' + resto + ' min' : '')
            },

            textoRelativo (valor) {
                const fecha = this.aFecha(valor)
                if (!fecha) return 'sin datos'
                return 'hace ' + this.humano(this.minutosDesde(valor)) + ' (' + this.$moment(fecha).format('HH:mm:ss') + ')'
            },

            textoCorto (valor) {
                const min = this.minutosDesde(valor)
                if (min === null) return '-'
                if (min < 1) return 'ahora'
                return this.humano(min)
            },

            tieneBateria (v) {
                return !!v && !!v.bateria && Number.isFinite(v.bateria.nivel)
            },

            // Las reglas solo exigen `userId` y `ultimoLatido`, asi que un documento
            // puede llegar sin nombre. Mejor identificarlo por id que mostrar vacio.
            nombreDe (v) {
                if (!v) return 'Sin identificar'
                return v.nombre || ('Sin identificar (' + (v.userId || v.id) + ')')
            },

            colorBateria (v) {
                const n = this.tieneBateria(v) ? v.bateria.nivel : null
                if (n === null) return 'grey'
                if (n <= 20) return 'red'
                if (n <= 40) return 'orange'
                return 'green'
            },

            claseBateria (v) {
                const color = this.colorBateria(v)
                return color + '--text'
            },

            // ---------------------------------------------------------------- Mapa

            tienePosicion (v) {
                return Number.isFinite(v.lat) && Number.isFinite(v.lng)
                    && !(v.lat === 0 && v.lng === 0)
            },

            // Se usan simbolos y no marcadores con DOM propio: son mas baratos y no
            // necesitan reposicionarse a mano en cada pan del mapa.
            /*
             * Cada estado tiene su propia FORMA, no solo su color.
             *
             * Esta es una pantalla rojo/verde, y cerca del 8% de los hombres tiene
             * alguna forma de daltonismo: para un deuteranope el verde #2e7d32 y el
             * rojo #c62828 se ven como dos marrones casi iguales. Antes los seis
             * estados eran el mismo circulo y lo unico que cambiaba era el relleno,
             * asi que en el mapa la informacion era ilegible para esas personas.
             *
             * Tambien se cachea por estado: devolver un objeto nuevo en cada render
             * hacia que el watcher del prop `icon` disparara `setIcon()` sobre todos
             * los marcadores en cada tick del reloj, sin que nada hubiera cambiado.
             */
            iconoDe (v) {
                if (!this.google) return null
                const estado = this.estadoDe(v)
                if (!this.iconos) this.iconos = {}
                if (!this.iconos[estado]) {
                    const forma = FORMAS[estado] || FORMAS.fuera
                    this.iconos[estado] = {
                        path: forma.path === 'CIRCLE' ? this.google.maps.SymbolPath.CIRCLE : forma.path,
                        scale: forma.scale,
                        fillColor: COLORES[estado] || '#9e9e9e',
                        fillOpacity: 0.95,
                        strokeColor: '#ffffff',
                        strokeWeight: 2
                    }
                }
                return this.iconos[estado]
            },

            // Icono para la lista: segunda via de lectura, independiente del color.
            iconoEstado (v) {
                const estado = this.estadoDe(v)
                if (estado === 'ok') return 'check_circle'
                if (estado === 'demorado') return 'schedule'
                if (estado === 'detenido') return 'gps_off'
                if (estado === 'fuera') return 'radio_button_unchecked'
                return 'error'
            },

            colorEstado (v) {
                const c = this.clase(v)
                if (c === 'ok') return 'green darken-3'
                if (c === 'aviso') return 'orange darken-4'
                if (c === 'fuera') return 'grey'
                return 'red darken-2'
            },

            zIndexDe (v) {
                return PESO[this.estadoDe(v)] || 0
            },

            seleccionar (v, centrar) {
                this.seleccionadoId = v.id
                if (centrar && this.tienePosicion(v) && this.$refs.mapa) {
                    this.$refs.mapa.$mapPromise.then(mapa => {
                        mapa.panTo({ lat: v.lat, lng: v.lng })
                        if (mapa.getZoom() < 16) mapa.setZoom(16)
                    }).catch(() => {})
                }
            },

            // OJO con el orden: antes esto empezaba con `if (!this.google) return` y el
            // llamador marcaba `yaCentre = true` ANTES de llamar. El script de Maps
            // empieza a cargar en el mounted del mapa (~300-1500 ms) y el snapshot de
            // Firestore llega antes (~50-300 ms), asi que la funcion salia en la
            // primera linea con el latch ya quemado y el mapa se quedaba en zoom 12
            // sobre Bogota en cada carga de la pantalla. `$mapPromise` ya resuelve
            // despues de que el API cargo, asi que el guard era innecesario y dañino.
            ajustarVista () {
                if (!this.$refs.mapa) return
                const puntos = this.conPosicion
                if (puntos.length === 0) return

                this.$refs.mapa.$mapPromise.then(mapa => {
                    if (puntos.length === 1) {
                        mapa.setCenter({ lat: puntos[0].lat, lng: puntos[0].lng })
                        mapa.setZoom(17)
                    } else {
                        const limites = new this.google.maps.LatLngBounds()
                        puntos.forEach(v => limites.extend({ lat: v.lat, lng: v.lng }))
                        mapa.fitBounds(limites, 48)
                    }
                    this.yaCentre = true
                }).catch(() => {})
            },

            verRecorrido (v) {
                this.$router.push({
                    path: '/tracking',
                    query: { user: v.userId || v.id, fecha: this.$moment().format('YYYY-MM-DD') }
                }).catch(() => {})
            },

            // ------------------------------------------------------------ Datos

            // `posiciones_actuales` es una coleccion nueva: mientras las reglas de
            // Firestore no esten desplegadas, el `match /{documento=**}` del final las
            // cierra y esto devuelve permission-denied. Decir "revisa la conexion" ahi
            // manda a buscar el problema al lugar equivocado.
            explicarLectura (error) {
                const codigo = error && error.code ? error.code : ''
                if (codigo === 'permission-denied') {
                    return 'Esta pantalla todavia no esta habilitada en la base de datos: falta '
                        + 'desplegar las reglas de Firestore que declaran la coleccion "posiciones_actuales".'
                }
                if (codigo === 'unavailable' || codigo === 'deadline-exceeded') {
                    return 'Sin conexion con la base de datos. Reintenta cuando vuelva la red.'
                }
                if (codigo === 'unauthenticated') {
                    return 'Tu sesion expiro. Volve a iniciar sesion.'
                }
                return 'No se pudieron cargar las posiciones en vivo'
                    + (codigo ? ' (' + codigo + ')' : '')
                    + (error && error.message ? ': ' + error.message : '') + '.'
            },

            escuchar () {
                // Reentrante: el boton de reintentar la vuelve a llamar, asi que hay
                // que cortar el listener anterior antes de abrir otro.
                if (this.cortar) { this.cortar(); this.cortar = null }
                this.cargando = true
                this.errorMsg = ''

                // Un solo listener sobre una coleccion del tamaño de la nomina.
                // La alternativa -un listener por vigilante sobre `tracking`, que
                // tiene millones de documentos- seria carisima y no haria falta.
                this.cortar = db.collection('posiciones_actuales').onSnapshot(
                    snapshot => {
                        this.reportes = snapshot.docs.map(doc => {
                            const datos = doc.data()
                            // El id del documento no es enumerable en algunos
                            // wrappers, asi que se copia explicitamente.
                            return Object.assign({}, datos, { id: doc.id })
                        })
                        this.cargando = false
                        this.errorMsg = ''

                        // Se centra una sola vez, en la primera carga con datos: si
                        // se hiciera en cada snapshot, el mapa saltaria cada vez que
                        // un vigilante da un paso.
                        if (!this.yaCentre && this.conPosicion.length > 0) {
                            this.$nextTick(() => this.ajustarVista())
                        }
                    },
                    error => {
                        this.cargando = false
                        this.errorMsg = this.explicarLectura(error)
                    }
                )
            }
        },
        created () {
            this.escuchar()
            // El paso del tiempo es parte del dato: sin este tick, un vigilante que
            // dejo de reportar seguiria mostrandose en verde hasta el proximo cambio.
            this.reloj = setInterval(() => { this.ahora = Date.now() }, 15000)
        },
        beforeDestroy () {
            // Sin esto el listener queda vivo toda la sesion, consumiendo lecturas
            // aunque nadie este mirando la pantalla.
            if (this.cortar) this.cortar()
            if (this.reloj) clearInterval(this.reloj)
        }
    }
</script>

<style scoped>
    .tarjeta-cifra {
        padding: 10px 14px;
        border-left: 4px solid #9e9e9e;
    }

    .tarjeta-cifra .cifra {
        font-size: 26px;
        font-weight: 600;
        line-height: 1.1;
    }

    .tarjeta-cifra .rotulo {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
        text-transform: uppercase;
        letter-spacing: 0.4px;
    }

    .tarjeta-cifra .rotulo-extra {
        font-size: 11px;
        color: #ef6c00;
        margin-top: 2px;
    }

    .tarjeta-cifra.ok { border-left-color: #2e7d32; }
    .tarjeta-cifra.aviso { border-left-color: #ef6c00; }
    .tarjeta-cifra.alerta { border-left-color: #c62828; }
    .tarjeta-cifra.alerta .cifra { color: #c62828; }

    .pulso { animation: latido 2s ease-in-out infinite; }

    @keyframes latido {
        0%, 100% { box-shadow: 0 0 0 0 rgba(198, 40, 40, 0); }
        50% { box-shadow: 0 0 0 4px rgba(198, 40, 40, 0.15); }
    }

    /* Las marcas de la leyenda replican las formas del mapa. */
    .marca {
        display: inline-block;
        width: 11px;
        height: 11px;
        background: #9e9e9e;
        vertical-align: middle;
    }

    .marca.circulo { border-radius: 50%; }
    .marca.circulo.chico { width: 8px; height: 8px; }
    .marca.cuadrado { border-radius: 2px; }
    .marca.triangulo {
        width: 0;
        height: 0;
        background: transparent !important;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 11px solid #ef6c00;
    }

    .marca.ok { background: #2e7d32; }
    .marca.aviso { background: #ef6c00; }
    .marca.alerta { background: #c62828; }
    .marca.fuera { background: #bdbdbd; }

    .leyenda { color: rgba(0, 0, 0, 0.6); }

    .lista-personal { max-height: 470px; overflow-y: auto; }
    .lista-personal .activo { background: rgba(21, 101, 192, 0.08); }

    .globo { min-width: 200px; max-width: 260px; }
    .globo-nombre { font-weight: 600; font-size: 14px; margin-bottom: 2px; }
    .globo-linea { font-size: 12px; color: rgba(0, 0, 0, 0.7); }
    .globo-estado { font-size: 12px; font-weight: 600; margin: 4px 0; }
    .globo-estado.ok { color: #2e7d32; }
    .globo-estado.aviso { color: #ef6c00; }
    .globo-estado.alerta { color: #c62828; }
    .globo-estado.fuera { color: #757575; }
    .globo-integridad {
        font-size: 12px;
        font-weight: 600;
        color: #c62828;
        margin-top: 4px;
    }
</style>
